import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_TIMEOUT = 5000;
export function addAlert({
  titleKey,
  messageKey,
  options,
  elements,
  type
}) {
  const payload = {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: titleKey
    }),
    type,
    timeout: DEFAULT_TIMEOUT
  };
  if (messageKey && options) {
    payload.message = /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: messageKey,
      options: options,
      elements: elements
    });
  } else if (messageKey) {
    payload.message = /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: messageKey
    });
  }
  FloatingAlertStore.addAlert(payload);
}